// extracted by mini-css-extract-plugin
export default {"ConfirmAction":"ConfirmAction_ConfirmAction"};